import React from 'react';
import { useTranslation } from 'react-i18next';

import * as CUI from '../../CUI';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleExclamation } from '@fortawesome/pro-regular-svg-icons';
import { Link } from 'react-router-dom';
import { globalConfig } from '@/globalConfig';

/**
 * Check eligibility fail screen
 * @returns React.FC
 * */
export const CheckEligibilityFail: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="eligibility-fail-container">
      <div className="circle-container check center">
        <FontAwesomeIcon icon={faCircleExclamation} />
      </div>

      <div className="page-title">{t('NOT_ELIGIBLE')}</div>
      <div className="page-subtitle">{t('YOU_CANNOT_GET_SCHOLARSHIP')}</div>
      <div className="page-subtitle mob-16">
        {t('ELIGIBILITY_FAIL_REASON_THRESHOLD')}
      </div>
      <div className="page-subtitle mob-16">
        {t('ELIGIBILITY_FAIL_REASON_ALREADY_REGISTERED')}
      </div>
      <div className="page-subtitle mob-16">
        {t('ELIGIBILITY_FAIL_REASON_PHONE_OR_EMAIL')}
      </div>
      <Link to={globalConfig.routes.main()}>
        <CUI.Button _btnPrimaryPerach>{t('BACK_TO_HOMEPAGE')}</CUI.Button>
      </Link>
    </div>
  );
};
